import {REACTION_RECIPIENT_ALL} from '../../configs/reactions';

/**
 * Кому бот может сам, без повода, отправить реакцию (повторяющийся цикл
 * BotReactionsSimulator): любой участник матча, кроме самого бота, или «Всем»
 * — равновероятным вариантом наравне с игроками.
 *
 * «Явных» ботов среди адресатов нет: они помечены ботом для всех, и реакция
 * им от неявного бота выглядит странно — писать боту незачем, а неявный бот
 * изображает человека. Ответить явный бот все равно не может (см.
 * checkIfBotSendsReactions).
 *
 * @param {Array} players - игроки матча
 * @param {string} botId - id бота-отправителя
 * @returns {Array<string>} id адресатов и REACTION_RECIPIENT_ALL
 */
export const getBotReactionRecipientIds = (players, botId) => [
  ...(players || [])
    .filter((player) => player.id !== botId && !player.isVisibleBot)
    .map((player) => player.id),
  REACTION_RECIPIENT_ALL,
];
